export default __webpack_public_path__ + "static/media/report-summary.0d7ea2dc.svg";